import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isVisible: boolean
}

export const Container = styled.div<Props>`
	display: ${({ isVisible }) => (isVisible ? 'inline-block' : 'none')};
	transition: height 135ms ease;
	width: 100%;
	text-align: left;
	margin: 8px 0 0 16px;
	color: ${({ theme }) => theme.color.input.borderError};
	font: ${helpers.fonts.input.hint};
`
